import {useContext, useState} from 'react'
import {MembersReportPageContext} from '../../context'
import {SideFilter} from '../../../../components/SideFilter'
import useSaveFilter from '../../hooks/useSaveFilter'

const MembersReportHeader = () => {
  const {
    filtersData,
    refetch,
    isLoading: loading,
  } = useContext(MembersReportPageContext)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const {isOperationLoading, onSaveFilter} = useSaveFilter(refetch)

  return (
    <div className='d-flex justify-content-between mb-10'>
      <div></div>
      <div>
        <SideFilter
          filterData={filtersData}
          isOperationLoading={isOperationLoading || loading}
          onApply={onSaveFilter}
          onCancel={() => setIsDrawerOpen(false)}
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
          filterType={'individual_project_members_report'}
        />
      </div>
    </div>
  )
}

export default MembersReportHeader
